import { ApiResponse, TicketManagerQueue } from '@vision/ui/interfaces';
import { TicketManagerQueueOrderType } from '@vision/ui/enums';

interface TicketManagerQueueResponseDto {
  id: string;
  name: string;
  ordering: TicketManagerQueueOrderType;
  project_id: string;
  ticket_count?: number;
}

export function normalizeTicketManagerQueue(dto: TicketManagerQueueResponseDto): TicketManagerQueue {
  return {
    id: dto.id,
    name: dto.name,
    ordering: dto.ordering,
    projectId: dto.project_id,
    ticketCount: dto.ticket_count,
  };
}

export function normalizeTicketManagerQueuesResponse(
  response: ApiResponse<TicketManagerQueueResponseDto[]>,
): ApiResponse<TicketManagerQueue[]> {
  return {
    ...response,
    data: response.data.map(normalizeTicketManagerQueue),
  };
}

export function normalizeTicketManagerQueueResponse(
  response: ApiResponse<TicketManagerQueueResponseDto>,
): ApiResponse<TicketManagerQueue> {
  return {
    ...response,
    data: normalizeTicketManagerQueue(response.data),
  };
}
